export default "__VITE_ASSET__CNSe8Y9$__"